import { render } from "./Login.vue?vue&type=template&id=6801a54a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6801a54a"

export default script